'use client';

import { AppNextLink } from '@/features/app-next-link';
import { NavigationCarousel } from '@/features/carousel';
import { getNextLevelCategoies } from '@/features/filter/utils/category-helpers';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { EasyAccess } from '@/features/tag';
import { cn } from '@/utils/cn';
import CombinationsListSkeleton from './combinations-list-skeleton';
import { isCategoryMetas } from '../_utils/type-guards';
import { useBasicMetas } from '../_utils/use-basic-metas';
import { useGetCombinationsList } from '../_utils/use-get-combinations-list';
import usePLPData from '../_utils/use-plp-data';
interface Props {
  cat_id?: string | null;
}
const CombinationsList = ({
  cat_id
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data,
    isLoading
  } = useGetCombinationsList({
    cat_id: cat_id || ''
  });
  const {
    basicMetas
  } = useBasicMetas();
  const {
    pageResponse
  } = usePLPData();
  const categoryMetas = isCategoryMetas(basicMetas) ? basicMetas : undefined;
  const facetsCategories = pageResponse?.facets?.categories || [];
  const categories = getNextLevelCategoies(facetsCategories || undefined, categoryMetas?.nameEn || undefined) || [];
  const isLastLevelCategory = categories.length === 0;
  if (isLoading) return <CombinationsListSkeleton />;
  if (!isLastLevelCategory || !data?.length) return null;
  return <div data-test='combinations-list' className={cn('relative mb-3', {
    'mt-5': isMobile
  })} data-sentry-component="CombinationsList" data-sentry-source-file="combinations-list.tsx">
            {isMobile ? <NavigationCarousel options={{
      perView: 'auto',
      mode: 'snap',
      spacing: 4
    }} containerClassName='[&>*:last-child]:pl-3' skeleton={<CombinationsListSkeleton />}>
                    {data?.map(({
        title,
        slug
      }) => {
        return <EasyAccess sendEvents={false} key={slug} href={`/facets/${slug}`} size='medium' className='keen-slider__slide min-w-fit max-w-fit'>
                                {title}
                            </EasyAccess>;
      })}
                </NavigationCarousel> : data?.map(({
      title,
      slug
    }) => {
      return <AppNextLink key={slug} href={`/facets/${slug}`} className='mb-3 block text-body-14'>
                            {title}
                        </AppNextLink>;
    })}
        </div>;
};
export default CombinationsList;